interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, Math.min(current - 2, total - 4));
  const end = Math.min(total, start + 4);
  for (let i = start; i <= end; i += 1) {
    pages.push(i);
  }

  const baseBtn =
    "flex h-9 min-w-9 items-center justify-center rounded-md border px-3 text-sm transition-colors cursor-pointer";

  return (
    <nav aria-label="分页导航" className="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        className={`${baseBtn} border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
        onClick={() => onChange(current - 1)}
        disabled={current <= 1}
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {start > 1 && (
        <>
          <button
            type="button"
            className={`${baseBtn} border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600`}
            onClick={() => onChange(1)}
          >
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-400">…</span>}
        </>
      )}

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          className={`${baseBtn} ${
            page === current
              ? "border-primary-500 bg-primary-500 text-background-50"
              : "border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
          }`}
          onClick={() => onChange(page)}
        >
          {page}
        </button>
      ))}

      {end < total && (
        <>
          {end < total - 1 && <span className="px-1 text-foreground-400">…</span>}
          <button
            type="button"
            className={`${baseBtn} border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600`}
            onClick={() => onChange(total)}
          >
            {total}
          </button>
        </>
      )}

      <button
        type="button"
        className={`${baseBtn} border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
        onClick={() => onChange(current + 1)}
        disabled={current >= total}
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}